<template>
  <div class="container">
    <h1 style="color:#fff;">Project</h1>
    <div class="card">
      <div class="card-image waves-effect waves-block waves-light">
        <img
          class="activator"
          src="https://source.unsplash.com/1200x900/?design,phone"
        />
      </div>
      <div class="card-content">
        <span class="card-title activator grey-text text-darken-4"
          >Shiri web dev | React.js Firebase Firestore
<i class="material-icons right">more_vert</i></span
        >
        <p><a href="https://react-firebase-d6e6b.web.app/guest">This is a link</a></p>
      </div>
      <div class="card-reveal">
        <span class="card-title grey-text text-darken-4"
          >Shiri web dev | React.js Firebase Firestore<i class="material-icons right">close</i></span
        >
        <p>
          'Shiri Web Dev' guest book project with React.js firebase and firestore. This project is a guest book
          where users can add their name and message and function of CRUD(Creat, Read, Update, Delete).
          I tried to learn and exprience various technologies and frameworks.
        </p>
      </div>
    </div>
    <div class="card">
      <div class="card-image waves-effect waves-block waves-light">
        <img
          class="activator"
          src="https://source.unsplash.com/1200x900/?design,mac"
        />
      </div>
      <div class="card-content">
        <span class="card-title activator grey-text text-darken-4"
          >Shiri Lab | Vue.js Node.js Express.js <i class="material-icons right">more_vert</i></span
        >
        <p><a href="https://fullstact-vue.web.app/">This is a link</a></p>
      </div>
      <div class="card-reveal">
        <span class="card-title grey-text text-darken-4"
          >Shiri Lab | Vue.js Node.js Express.js<i class="material-icons right">close</i></span
        >
        <p>
          'Shiri lab' upload project with Vue.js, Express.js, Node.js.
          It inclueds web-token, hash and salt etc.
          I tried to learn and exprience various technologies and frameworks.
          This project inclueds function of CRUD(Creat, Read, Update, Delete).
        </p>
      </div>
    </div>
    <div class="card">
      <div class="card-image waves-effect waves-block waves-light">
        <img
          class="activator"
          src="https://source.unsplash.com/1200x900/?design,program"
        />
      </div>
      <div class="card-content">
        <span class="card-title activator grey-text text-darken-4"
          >Marketing APIs<i class="material-icons right">more_vert</i></span
        >
        <p><a href="https://marketingweb-2c47f.web.app/">This is a link</a></p>
      </div>
      <div class="card-reveal">
        <span class="card-title grey-text text-darken-4"
          >Marketing APIs<i class="material-icons right">close</i></span
        >
        <p>
         Various APIs for marketing and sales.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "project",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
